module.exports = __webpack_public_path__ + "img/img_9.88b7cf63.jpeg";